import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-5 pb-5 container" }
const _hoisted_2 = { class: "page-content shadow-sm" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap p-3" }
const _hoisted_4 = { class: "month-filter d-flex align-items-center" }
const _hoisted_5 = {
  for: "month",
  class: "mb-0 me-2"
}
const _hoisted_6 = { class: "d-flex justify-content-center gap-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "event-dialog"
}
const _hoisted_10 = { class: "event-dialog__header" }
const _hoisted_11 = { class: "d-flex align-items-center gap-2" }
const _hoisted_12 = { class: "m-0" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "event-dialog__body" }
const _hoisted_15 = { class: "material-icons" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "skeleton event-dialog__skeleton is-icon" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "skeleton event-dialog__skeleton is-label" }),
  /*#__PURE__*/_createElementVNode("span", { class: "skeleton event-dialog__skeleton is-text" })
], -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "event-dialog__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_ds_header = _resolveComponent("ds-header")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ds_calendar = _resolveComponent("ds-calendar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_ds_header, {
      title: _ctx.$t('group.title'),
      buttonText: _ctx.$t('group.register'),
      buttonRoute: "AddGroup"
    }, null, 8, ["title", "buttonText"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('group.fields.month')), 1),
          _createVNode(_component_Calendar, {
            id: "month",
            name: "month",
            view: "month",
            dateFormat: "MM yy",
            panelClass: "month-filter-panel",
            modelValue: _ctx.month,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.month) = $event)),
            onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectMonth($event)))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_ds_button, {
          type: "secondary",
          text: _ctx.$t('group.openCalendar'),
          leftIcon: "calendar_month",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.calendarVisible = true))
        }, null, 8, ["text"])
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.groups,
        responsiveLayout: "scroll",
        showGridlines: "",
        paginator: _ctx.groups.length > 10,
        rows: 10
      }, {
        empty: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('group.noGroup')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "name",
            header: _ctx.$t('group.fields.name'),
            sortable: true,
            removableSort: ""
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "status",
            header: "Status",
            sortable: true,
            removableSort: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                class: _normalizeClass('group-status status-' + slotProps.data.status)
              }, _toDisplayString(_ctx.statusLabel(slotProps.data.status)), 3)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "createdDate",
            header: _ctx.$t('group.fields.period'),
            sortable: true,
            removableSort: ""
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdDate)) + " - " + _toDisplayString(_ctx.formatDate(slotProps.data.finishDate)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('group.fields.hours')
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.hours(slotProps.data)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('group.fields.weekDays')
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.weekDays(slotProps.data)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('utils.actions'),
            style: { width: '7rem' },
            bodyClass: "text-center"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives((_openBlock(), _createElementBlock("span", {
                  class: "material-symbols-outlined pointer",
                  onClick: ($event: any) => (_ctx.openEvent(slotProps.data.id))
                }, [
                  _createTextVNode(" edit ")
                ], 8, _hoisted_7)), [
                  [
                    _directive_tooltip,
                    _ctx.$t('utils.edit'),
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("span", {
                  class: "material-icons delete-icon",
                  onClick: ($event: any) => (_ctx.confirmDelete(slotProps.data.id))
                }, [
                  _createTextVNode(" delete ")
                ], 8, _hoisted_8)), [
                  [
                    _directive_tooltip,
                    _ctx.$t('utils.delete'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              ])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "paginator"])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.calendarVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.calendarVisible) = $event)),
      modal: "",
      dismissableMask: "",
      class: "calendar-dialog",
      header: _ctx.$t('group.calendar'),
      style: { width: '70vw' },
      breakpoints: { '1400px': '82vw', '1000px': '95vw' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ds_calendar, {
          events: _ctx.alocations,
          tooltip: _ctx.eventTooltip,
          onEventClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectEvent($event))),
          onEditEvent: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openEvent($event))),
          onDeleteEvent: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmDelete($event))),
          onUpdatedPeriod: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getRange($event))),
          onUpdatedMode: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getRange($event.period)))
        }, {
          eventDialog: _withCtx(({ close }) => [
            (_ctx.selectedGroup)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.selectedGroup.name), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass('group-status status-' + _ctx.selectedGroup.status)
                      }, _toDisplayString(_ctx.statusLabel(_ctx.selectedGroup.status)), 3)
                    ]),
                    _createElementVNode("span", {
                      class: "material-icons event-dialog__close",
                      onClick: close
                    }, " close ", 8, _hoisted_13)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGroupInfo, (info) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "event-dialog__row",
                        key: info.label
                      }, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(info.icon), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("small", null, _toDisplayString(info.label), 1),
                          _createElementVNode("p", null, _toDisplayString(info.value), 1)
                        ])
                      ]))
                    }), 128)),
                    (_ctx.loadingGroup)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(2, (row) => {
                          return _createElementVNode("div", {
                            class: "event-dialog__row",
                            key: 'loading-' + row
                          }, _hoisted_18)
                        }), 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_ds_button, {
                      type: "tertiary",
                      isError: "",
                      leftIcon: "delete",
                      text: _ctx.$t('utils.delete'),
                      onClick: ($event: any) => {close(); _ctx.confirmDelete(_ctx.selectedGroup.id)}
                    }, null, 8, ["text", "onClick"]),
                    _createVNode(_component_ds_button, {
                      type: "primary",
                      leftIcon: "edit",
                      text: _ctx.$t('utils.edit'),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openEvent(_ctx.selectedGroup.id)))
                    }, null, 8, ["text"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["events", "tooltip"])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}